export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const media = (path) => (path ? `${BACKEND_URL}${path}` : "");

export const inr = (n) => (n == null ? "—" : "₹" + Math.round(n).toLocaleString("en-IN"));

export const fromPrice = (model) => (model?.variants?.length ? Math.min(...model.variants.map((v) => v.price)) : null);

export const emi = (principal, ratePct, months) => {
  if (principal <= 0) return 0;
  const r = ratePct / 12 / 100;
  if (r === 0) return principal / months;
  const f = Math.pow(1 + r, months);
  return (principal * r * f) / (f - 1);
};

export const bodyOf = (m) => (m.category === "Electric" ? "Scooter" : m.category);

export const relTime = (isoStr) => {
  if (!isoStr) return "—";
  const s = Math.max(0, (Date.now() - new Date(isoStr).getTime()) / 1000);
  if (s < 60) return `${Math.round(s)}s ago`;
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86400)} d ago`;
};

export const fmtDateTime = (isoStr) =>
  isoStr ? new Date(isoStr).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";
